import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Progress } from '@/components/ui/progress';
import { Users } from 'lucide-react';
import type { ManagerIntelligenceStats } from '@/hooks/useManagerIntelligenceStats';

interface Props { stats: ManagerIntelligenceStats | null | undefined; isSelfView: boolean; }

export function ManagerCoachingImpact({ stats }: Props) {
  const formatRate = (r: number | null) => r != null ? `${Math.round(r * 100)}%` : '—';
  
  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-lg flex items-center gap-2"><Users className="h-5 w-5" />Coaching Impact</CardTitle>
        <CardDescription>How team performance improves after manager interventions</CardDescription>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="p-3 bg-muted/30 rounded-lg space-y-2">
          <div className="flex justify-between text-sm"><span>Technician Improvement Rate</span><span className="font-semibold">{formatRate(stats?.coachedTechImprovementRate)}</span></div>
          {stats?.coachedTechImprovementRate != null && <Progress value={stats.coachedTechImprovementRate * 100} className="h-2" />}
        </div>
        <div className="p-3 bg-muted/30 rounded-lg space-y-2">
          <div className="flex justify-between text-sm"><span>Mismatch Reduction Rate</span><span className="font-semibold">{formatRate(stats?.mismatchReductionRate)}</span></div>
          {stats?.mismatchReductionRate != null && <Progress value={stats.mismatchReductionRate * 100} className="h-2" />}
        </div>
      </CardContent>
    </Card>
  );
}
